import { Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';

export const PurchasePriceCalculation: FC = () => {
  const { t } = useTranslation();
  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.purchasepricecalculation.title')}>
      <Typography variant="body1">{t('dashboard.assets.addedit.investment.purchasepricecalculation.description')}</Typography>
    </LaunchpadCard>
  );
};
